<template>
  <ViewCustomData entityName="request_user" entitySpec="data" serviceName="BaseService" :columns="REQUEST_USER_COLUMNS"
    :toolbarFilters="REQUEST_USER_TOOLBAR_FILTRES" scrollHeight="770px" :dictionary="REQUEST_USER_DICTIONARY"
    @selectedRow="onSelectedRow" :rows="52" ref="viewCustomData" :dialog="RequestUserDialog"
    :dialogOptions="dialogOptions" @dictIsReady="dictIsReady" :drawRow="rowClass" />
</template>

<script setup>
import { ref, shallowRef } from 'vue';
import RequestUserDialogComponent from './RequestUserDialog.vue';
import { REQUEST_USER_DICTIONARY, REQUEST_USER_TOOLBAR_FILTRES, REQUEST_USER_COLUMNS } from './requestUserConstants.js';

const selected = ref(null);

const dialogOptions = ref({});

const RequestUserDialog = shallowRef(RequestUserDialogComponent)

const onSelectedRow = (value) => {
  selected.value = value;
}

const dictIsReady = (options, data) => {
  dialogOptions.value[options] = data;
}

const rowClass = (data) => {
  switch (data.__reject) {
    case 'Red':
      return "row-accessories-red";
    case 'Pink':
      return "row-accessories-orange";
    case 'Yellow':
      return "row-accessories-yellow";
    case 'Lime':
      return "row-accessories-green";
    default:
      return null;
  }
}
</script>

<style scoped lang="scss">
::v-deep(.row-accessories-blue) {
  background-color: rgba(57, 26, 196, 1) !important;
}

::v-deep(.row-accessories-green) {
  background-color: #c0dcc0 !important;
}


::v-deep(.row-accessories-yellow) {
  background-color: #fcfa98 !important;
}

::v-deep(.row-accessories-orange) {
  background-color: #f8d69c !important;
}

::v-deep(.row-accessories-red_ligt) {
  background-color: #f58484 !important;
}
</style>
